module.exports = __webpack_public_path__ + "assets/kong.1d1de18b.svg";